import { metricNames } from '@linearb/linjs-common';
import {
  isCustomStagesMetric,
  DEFAULT_TIME_RANGE_KEY
} from 'common/constants/metrics';
import { groupBy, get } from 'lodash';
export const getParamKeysByMetricName = metricName => {
  if (isCustomStagesMetric(metricName)) {
    return {
      periodRangeKey: DEFAULT_TIME_RANGE_KEY,
      orderByKey: metricName
    };
  }
  return mapMetricNameToParamKeys[metricName] || {};
};

const mapMetricNameToParamKeys = {
  [metricNames.CYCLE_TIME]: {
    periodRangeKey: 'cycle_time_updated_at',
    orderByKey: 'cycle_time'
  },
  [metricNames.TIME_TO_PR]: {
    // Coding
    periodRangeKey: 'coding_ended_at',
    orderByKey: 'time_to_pr'
  },
  [metricNames.TIME_TO_REVIEW]: {
    // PickUp
    periodRangeKey: 'reviewed_at',
    orderByKey: 'time_to_review'
  },
  ...[
    metricNames.REVIEW_TIME,
    metricNames.BRANCH_TIME_TO_APPROVE,
    metricNames.BRANCH_TIME_TO_MERGE
  ].reduce((acc, current) => {
    // Review
    acc[current] = {
      periodRangeKey: 'merged_at',
      orderByKey: 'review_time'
    };
    return acc;
  }, {}),
  [metricNames.TIME_TO_PROD]: {
    // Deploy Time
    periodRangeKey: 'released_at',
    orderByKey: 'time_to_prod'
  },
  [metricNames.NEW_WORK]: {
    periodRangeKey: 'committed_at',
    orderByKey: 'new_work'
  },
  [metricNames.REWORK]: {
    periodRangeKey: 'committed_at',
    orderByKey: 'rework'
  },
  [metricNames.REFACTOR]: {
    periodRangeKey: 'committed_at',
    orderByKey: 'refactor'
  },
  ...[
    metricNames.PR_MERGED,
    metricNames.PR_MERGED_WITHOUT_REVIEW,
    metricNames.PR_SIZE,
    metricNames.REVIEW_DEPTH,
    metricNames.PR_NEW
  ].reduce((acc, current) => {
    acc[current] = {
      periodRangeKey: 'merged_at',
      orderByKey: 'pr.size.total'
    };
    return acc;
  }, {})
};

export const METRIC_RAW_EVENTS_DATA_ENRICHMENT = {
  [metricNames.REVIEW_DEPTH]: (rawMetricData, items) => {
    const itemsMap = groupBy(rawMetricData, 'pull_request_id');
    return items.map(item => {
      const totalCommentsCount = item.comment_count;
      const totalReviewsCount = item.reviews_count;
      const teamCommentCount = get(itemsMap, [item.id, 0, 'value'], 0);
      const teamReviewsCount = get(itemsMap, [item.id, 0, 'total_reviews'], 0);
      return {
        ...item,
        comment_count:
          totalCommentsCount !== teamCommentCount
            ? `${totalCommentsCount} (${
                totalCommentsCount - teamCommentCount
              } external)`
            : totalCommentsCount,
        reviews_count:
          totalReviewsCount !== teamReviewsCount
            ? `${totalReviewsCount} (${
                totalReviewsCount - teamReviewsCount
              } external)`
            : totalReviewsCount
      };
    });
  }
};
